
import React, { useContext } from "react";
import { FeedContext } from "../../../utils/context/feedContext";
import PageAttachment from "./PageAttachment";
import { PostItem } from "./PostItem";
import OpenGraphPreview from "opengraph-react"; 
import api_config from "../../../settings/api.config";

const PostItemAttachment = ({ attachment, owner_data }) => {


    const {handleShowAttachment} = useContext(FeedContext); 
  
    if (attachment?.attachment_type?.includes("activity_action")) {
      if(!attachment.shared_post_data){
        console.log("attachment with no shared post data: ", attachment);
        return null; 
      }
      return (
        <PostItem
          postData={attachment.shared_post_data[0]}
          key={`post-item-attachment-${attachment.attachment_id}`}
          handles={{}}
          actionsOff={true}
          commentsOff={true}
        />
      );
    }
  
    if (attachment?.attachment_type?.includes("photo")) {
      
      const image = attachment.image_main || attachment.image_medium;
      const imageWidth = image?.size?.width || 900; // default width if not provided
      const imageHeight = image?.size?.height || 900; 

      const aspectRatio = imageWidth / imageHeight;

      if(owner_data.subject_id === 2218) {
        console.log("Test attachment: ", attachment);
        console.log("Test attachment aspect ratio: ", aspectRatio);
      }

      return (
        <>
        <div
          style={{
            aspectRatio: aspectRatio, 
            width: "100%", 
            overflow: 'hidden'
          }}
        >
          <img
            onClick={() => {
              handleShowAttachment({
                video_data: attachment, 
                type: "album_photo", 
                subject_type: "album_photo", 
                subject_id: attachment.photo_id, 
                navButtons: false, 
                owner_data: owner_data, 
                attachment: true 
              })
            }}
            style={{
              cursor: "pointer"
            }}
            src={attachment.image_medium || attachment.image_main.src}
            className="post-item-attachment-image"
            alt=""
            loading="eager"
            key={`post-item-attachment-${attachment.attachment_id}`}
          ></img>
        </div>
          {/* <VideoDisplay 
            show={showLightbox}
            onHide={handleHide}
            video_data={attachment}
            type={"album_photo"}
            subject_type="album_photo"
            subject_id={attachment.photo_id}
            navButtons={false}
            owner_data={owner_data}
            attachment={true}
          /> */}
        </>
        
      );
    }
  if (attachment?.attachment_type?.includes("video")) {
       
  
  
      if(attachment.attachment_video_type === 1 || attachment.attachment_video_type === 6) {
        // Build a YouTube-friendly embed with referrerPolicy/origin. Fall back to existing behavior for non-YouTube.
        const isYouTubeUrl = (raw) => {
          try {
            if (!raw) return false;
            const url = new URL(/^https?:/.test(raw) ? raw : `https://${raw}`);
            const host = url.hostname.replace(/^www\./, "");
            return (
              host.endsWith("youtube.com") ||
              host.endsWith("youtube-nocookie.com") ||
              host.endsWith("m.youtube.com") ||
              host.endsWith("youtu.be")
            );
          } catch {
            return false;
          }
        };

        const extractYouTubeId = (raw) => {
          try {
            if (!raw) return null;
            const url = new URL(/^https?:/.test(raw) ? raw : `https://${raw}`);
            const host = url.hostname.replace(/^www\./, "");
            if (host.includes("youtu.be")) {
              return url.pathname.split("/")[1] || null;
            }
            if (url.searchParams.get("v")) {
              return url.searchParams.get("v");
            }
            if (url.pathname.startsWith("/embed/")) {
              return url.pathname.split("/embed/")[1];
            }
            if (url.pathname.startsWith("/shorts/")) {
              return url.pathname.split("/shorts/")[1];
            }
            return null;
          } catch {
            return null;
          }
        };

        // Determine the raw URL to inspect based on type
        let rawUrl = attachment.attachment_video_url;
        if (attachment.attachment_video_type === 6) {
          try {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(rawUrl, "text/html");
            const el = parsed.querySelector("iframe");
            if (el && el.src) rawUrl = el.src;
          } catch {}
        }

        if (isYouTubeUrl(rawUrl)) {
          const vid = extractYouTubeId(rawUrl);
          if (vid) {
            let src = "";
            const isCapacitor = (() => {
              try { return typeof window !== "undefined" && /capacitor/i.test(window.location.origin); } catch { return false; }
            })();

            if (isCapacitor) {
              const basePath = api_config.hostname.replace("api.", "").replace("/api/rest", "");
              src = `${basePath}/yt-embed.html?v=${encodeURIComponent(vid)}`;
            } else {
              const base = `https://www.youtube-nocookie.com/embed/${vid}`;
              const params = new URLSearchParams({
                playsinline: "1",
                rel: "0",
                modestbranding: "1",
                enablejsapi: "1",
              });
              try {
                if (typeof window !== "undefined" && /^https?:/.test(window.location.origin)) {
                  params.set("origin", window.location.origin);
                }
              } catch {}
              src = `${base}?${params.toString()}`;
            }

            return (
              <div className="post-item-attachment-video">
                <iframe
                  src={src}
                  referrerPolicy="origin"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ border: 0, width: "100%", aspectRatio: "16 / 9" }}
                  title="YouTube video"
                />
              </div>
            );
          }
        }

        // Fallback: keep previous behavior for non-YouTube or if ID extraction failed
        let video_url = attachment.attachment_video_url;
        if(attachment.attachment_video_type === 6) {
          try {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(video_url, "text/html");
            const el = parsed.querySelector("iframe");
            if (el && el.src) video_url = el.src;
          } catch {}
        }

        return (
          <div className="post-item-attachment-video">
            {attachment.attachment_video_type === 6 ? (
              <iframe srcDoc={attachment.attachment_video_url} loading="lazy" />
            ) : (
              <iframe src={`https://${video_url}`} loading="lazy" />
            )}
          </div>
        );
      }
  
      return (
        <div className="post-item-attachment-video">
          <div className="play-video-button"></div>
          <video autoPlay={false} onClick={(e)=>{e.preventDefault(); 
            handleShowAttachment({
              video_data: attachment, 
              type: "video", 
              subject_type: "video", 
              subject_id: attachment.photo_id, 
              navButtons: false, 
              owner_data: owner_data, 
              attachment: true
            })
          }}
            style={{
              cursor: "pointer"
            }}
          >
            <source src={attachment.attachment_video_url} />
          </video>
          {/* <VideoDisplay 
            show={showLightbox}
            onHide={handleHide}
            video_data={attachment}
            type={"video"}
            subject_type="video"
            subject_id={attachment.photo_id}
            navButtons={false}
            owner_data={owner_data}
            attachment={true}
          /> */}
        </div>
      );
    }
    if (attachment?.attachment_type?.includes("link")) {
      if(attachment.og_data) {
        // Helper: detect YouTube URLs and extract video id
        const getOgUrl = () => (
          attachment.og_data?.openGraph?.url ||
          attachment.og_data?.hybridGraph?.url ||
          attachment.og_data?.url ||
          attachment.uri
        );

        const isYouTubeUrl = (raw) => {
          try {
            if (!raw) return false;
            const url = new URL(/^https?:/.test(raw) ? raw : `https://${raw}`);
            const host = url.hostname.replace(/^www\./, "");
            return (
              host.endsWith("youtube.com") ||
              host.endsWith("youtube-nocookie.com") ||
              host.endsWith("m.youtube.com") ||
              host.endsWith("youtu.be")
            );
          } catch {
            return false;
          }
        };

        const extractYouTubeId = (raw) => {
          try {
            if (!raw) return null;
            const url = new URL(/^https?:/.test(raw) ? raw : `https://${raw}`);
            const host = url.hostname.replace(/^www\./, "");
            if (host.includes("youtu.be")) {
              // youtu.be/<id>
              return url.pathname.split("/")[1] || null;
            }
            if (url.searchParams.get("v")) {
              return url.searchParams.get("v");
            }
            if (url.pathname.startsWith("/embed/")) {
              return url.pathname.split("/embed/")[1];
            }
            if (url.pathname.startsWith("/shorts/")) {
              return url.pathname.split("/shorts/")[1];
            }
            return null;
          } catch {
            return null;
          }
        };

        const ogUrl = getOgUrl();
        const isYoutube = isYouTubeUrl(ogUrl);

        if (isYoutube) {
          const vid = extractYouTubeId(ogUrl);
          if (vid) {
            let src = "";
            const isCapacitor = (() => {
              try { return typeof window !== "undefined" && /capacitor/i.test(window.location.origin); } catch { return false; }
            })();

            if (isCapacitor) {
              const basePath = api_config.hostname.replace("api.", "").replace("/api/rest", "");
              src = `${basePath}/yt-embed.html?v=${encodeURIComponent(vid)}`;
            } else {
              const base = `https://www.youtube-nocookie.com/embed/${vid}`;
              const params = new URLSearchParams({
                playsinline: "1",
                rel: "0",
                modestbranding: "1",
                enablejsapi: "1",
              });
              try {
                if (typeof window !== "undefined" && /^https?:/.test(window.location.origin)) {
                  params.set("origin", window.location.origin);
                }
              } catch {}
              src = `${base}?${params.toString()}`;
            }

            return (
              <div
                style={{
                  width: "100%",
                  overflow: "hidden",
                  aspectRatio: "16 / 9",
                }}
              >
                <iframe
                  src={src}
                  referrerPolicy="origin"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ border: 0, width: "100%", height: "100%" }}
                  title="YouTube video"
                />
              </div>
            );
          }
        }

        const site_name = attachment.og_data?.openGraph?.site_name || attachment.og_data?.hybridGraph?.site_name;     
        return(
          <div
            style={{
              width: "100%",
              overflow: 'hidden'
            }}
          >
            <OpenGraphPreview 
              dontMakeCall={true}
              results={attachment.og_data}
              dontUseVideo={site_name === "Rumble" || site_name === "Youtube"}
            />
          </div>
        ); 
      }
      return (
        <div className="post-item-attachment-link">
          <a href={attachment.uri} target="_blank" rel="noreferrer">
          <div className="post-item-attachment-link-image">
            <img src={attachment.image_main.src} alt="" />
          </div>
          <div className="post-item-attachment-link-content">
            <div className="post-item-attachment-link-title">
                {attachment.title}
            </div>
          </div>
          </a>
        </div>
      );
    }
    if (["sitepage_page", "group", "event"].includes(attachment?.attachment_type)) {
      return(
        <PageAttachment attachment={attachment} />
      )
    }
  
    return null;
  };


export default PostItemAttachment;